import {useCallback, useReducer} from 'react';
/**
 * Reducer to store previous and current values
 *
 * @param {object} state - Current reducer state
 * @param {object} action - Action to perform
 *
 * @returns {object} state - New state of reducer
 */
// @ts-expect-error TS(7030): Not all code paths return a value.
function reducer(state: any, action: any) {
  switch (action.type) {
    case 'update':
      return {
        previous: state.value,
        value: action.payload,
      };
  }
}
/**
 * Setup hook for storing current and previous state
 *
 * @param {any} original - The original value
 *
 * @returns {array} hook - Array of values and setter.
 */
export function useStateWithPrevious(original: any) {
  const [state, dispatch] = useReducer(reducer, {
    previous: undefined,
    value: original,
  });
  const setter = useCallback(
    (newValue: any) => dispatch({type: 'update', payload: newValue}),
    [],
  );
  return [{...state}, setter];
}
